import api from '../api';
import {Team} from '../models/Team';

export class TeamService {
    static async getTeams(): Promise<Team[]> {
        const res = await api.get('/teams');
        if (res.status !== 200) throw new Error('Erreur lors de la récupération des équipes');
        return res.data as Team[];
    }

    static async getTeamById(teamId: number): Promise<Team> {
        const { data, status } = await api.get(`/teams/${teamId}`)
        if (status !== 200) throw new Error("Impossible de récupérer l'équipe")
        return data as Team
    }

    static async createTeam(payload: { name: string; managerId: number; description?: string; startHour?: string }): Promise<Team> {
        const payloadWithDefaults = {
            startHour: '09:00',
            ...payload,
        };
        const res = await api.post('/teams', payloadWithDefaults);
        if (res.status !== 200 && res.status !== 201) throw new Error('Erreur lors de la création de l\'équipe');
        return res.data as Team;
    }

    static async deleteTeam(teamId: number): Promise<void> {
        const res = await api.delete(`teams/${teamId}`)
        if (res.status !== 200) throw new Error("Erreur lors de la suppression de l'équipe")
    }

    static async updateTeam(teamId: number, payload: any): Promise<any> {
        const res = await api.put(`/teams/${teamId}`, payload);
        if (res.status !== 200) throw new Error('Erreur lors de la mise à jour de l\'équipe');
        return res.data;
    }

    static async removeUserFromTeam(teamId: number, userId: number): Promise<void> {
        const res = await api.delete(`/teams/${teamId}/removeUser/${userId}`);
        if (res.status !== 200) throw new Error('Erreur lors de la suppression du membre');
    }

    static async getTeamsByManagerId(managerId: number): Promise<Team[]> {
        const { data, status } = await api.get(`/teams/manager/${managerId}`)
        if (status !== 200) throw new Error("Impossible de récupérer l'équipe du manager")
        return data as Team[]
    }

    static async addUserToTeam(teamId: number, userEmail: string): Promise<void> {
        const res = await api.post(`/teams/${teamId}/addUser/${encodeURIComponent(userEmail)}`);
        if (res.status !== 200) throw new Error('Erreur lors de l\'ajout du membre');
    }
}
